import { getToken } from './getToken';
import './spinner';

/**
 * Sorting class.
 *
 *  resultsBlk{String} - class wrapper of block
 *  sortWrap{String} - class wrapper of sort block
 *  sortBtn{String} - class of sort btn
 *  paginateBlk{String} - class of pagination block
 */
export class Sorting{

    constructor(data){
        this.resultsBlk = data.resultsBlk;
        this.sortWrap = data.sortWrap;
        this.sortBtn = data.sortBtn;
        this.url = '';
        this.method = 'GET';
        this.state = {
            letter: '',
            items: '',
            _token : ''
        };
        this.body = $('body');
    }

    init(){

        this.state._token = getToken();

        /**
         * Sorting
         */
        if(this.sortBtn) {
            this.initSortBtnClick(this.sortBtn);
        }

    }

    /**
     * Init function on click sort btn
     */
    initSortBtnClick(btn){
        let _this = this;
        this.body.on('click', btn, function(e) {
            e.preventDefault();
            let currItem = $(this).closest(_this.sortWrap).find(_this.sortBtn).filter('.__active');
            if (currItem) currItem.removeClass('__active');
            $(this).addClass('__active');
            _this.submitSorting($(this));
        });
    }

    /**
     * Submit function on click sort
     */
    submitSorting(thisBtn){
        let _this = this;
        let $sortWrap = $(thisBtn).closest(_this.sortWrap)
        _this.url = $sortWrap.data('action');
        _this.method = $sortWrap.data('method');
        _this.state.items = $sortWrap.data('items');
        _this.state.letter = $(thisBtn).data('letter');
        $(_this.resultsBlk).attr('data-category', $sortWrap.data('category'))
        $(_this.resultsBlk).attr('data-category-id', _this.state.letter)
        this.body.spinnerAdd('js_pagination-spinner');
        _this.request(_this.successSortingData);
    }

    /**
     * Append node items to wrap on click button sort
     *
     * @param data
     */
    appendItemsSorting(data){
        $(this.resultsBlk).html(data);
        $('#js_pagination-spinner').remove();
    }

    /**
     * On success request Sorting
     *
     * @param data
     */
    successSortingData(data){
        this.appendItemsSorting(data);
    }


    /**
     * Request to server with state.
     *
     * @param successCallback - callback function
     * @param url{String} - request url
     * @param method{String} - POST
     */
    request(successCallback, url = this.url, method = this.method){
        $.ajax({
            method: method,
            url: url,
            data: this.state,
            success: data => {
                if(typeof(successCallback) === 'function') {
                    successCallback.call(this, data);
                    return;
                }
            },
            error: function (error) {
                console.log('Error');
            }
        });
    }

}
